import React from 'react';

import Reset from '../../Components/Auth/Reset';
import Header from '../../Components/Auth/Header';


export default function ResetPage() {
  return (
    <div className="auth">
      <Header/>
      <Reset/>
    </div>
  );
}
